<div class="modal" id="fvp-input-modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header header-background">
                <span class="modal-title title-color" translate>Notice</span>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="container">
                    <span class="modal-title content-font">{{modalContent}}</span><br><br>
                    <div>
                        <label class="modal-title content-font" translate>{{contentLabel}}</label>
                         <input type="text" class="content-input" [(ngModel)]="inputValue" maxlength="15" (ngModelChange)="showError = inputValue? false:true;">
                         <span *ngIf="showError" class="no-input-error" translate>Please enter a Performance Parameter.</span>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="container footer-container-pos">
                    <button type="button" class="btn footer-btn" (click)="emitInputData()">Ok</button>
                    <button type="button" class="btn footer-btn footer-btn-cancel" data-dismiss="modal" (click)="inputValue='';showError=false;">Cancel</button>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal" id="fvp-message-modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-width" >
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                <div class="container">
                    <span class="modal-title content-font">{{modalContent}}</span><br><br>
                </div>
            </div>

            <div class="modal-footer footer-div">
                <div class="container footer-container">
                    <button type="button" class="btn footer-btn-ok" (click)="confirm('ok')">Ok</button>
                    <button type="button" class="btn footer-btn-ok btn-msg-cancel" *ngIf="showCancel" (click)="confirm('cancel')">Cancel</button>
                </div>
            </div>

        </div>
    </div>
</div>

